import React from "react";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppBar, Box, Divider, Tab, Tabs } from "@mui/material";
import { LeftSidebar } from "layout-blueprints";
import StandardHeader from "../../components/global/StandardHeader";
import BillingRules from "../../modules/settings/components/BillingRules";
import PeopleAccess from "../../modules/settings/components/PeopleAccess";
import CustomerSite from "../../modules/settings/components/CustomerSite";
import { canManagePeople } from "../../modules/settings/accessRoles";

// Older links used tab numbers: 1 was Users, 2 was Profile (now the avatar menu), 3 was Customer Site.
const LEGACY_TABS = { 0: "rules", 1: "people", 2: "rules", 3: "site" };

const tabSx = {
  "& .MuiTab-root": {
    color: "rgba(255, 255, 255, 0.7)",
    fontWeight: 500,
    textTransform: "none",
    "&:hover": { color: "rgba(255, 255, 255, 0.9)" },
    "&.Mui-selected": { color: "#ffffff", fontWeight: 600 },
  },
  "& .MuiTabs-indicator": { backgroundColor: "#d67104", height: 3 },
};

function Settings({ user }) {
  const [params, setParams] = useSearchParams();
  const me = user.details;

  const tabs = [
    { key: "rules", label: "Billing rules" },
    ...(canManagePeople(me)
      ? [
          { key: "people", label: "People & access" },
          { key: "site", label: "Customer site" },
        ]
      : []),
  ];
  const requested = LEGACY_TABS[params.get("tab")] || params.get("tab");
  const current = tabs.some((t) => t.key === requested) ? requested : "rules";

  document.title = "UBIL+ Settings";

  return (
    <LeftSidebar page="Settings">
      <StandardHeader title="Settings" />
      <Divider className="mb-3 mt-3" />

      <AppBar position="static" color="primary">
        <Tabs
          value={current}
          onChange={(e, value) => setParams({ tab: value }, { replace: true })}
          variant="scrollable"
          allowScrollButtonsMobile
          aria-label="Settings sections"
          sx={tabSx}
        >
          {tabs.map((t) => <Tab key={t.key} value={t.key} label={t.label} />)}
        </Tabs>
      </AppBar>

      <Box sx={{ pt: 3, pb: 4 }}>
        {current === "rules" && <BillingRules />}
        {current === "people" && <PeopleAccess />}
        {current === "site" && <CustomerSite />}
      </Box>
    </LeftSidebar>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(Settings);
